export default "__VITE_ASSET__C$0z5f2Y__"